/**
 * Is the current user a "manager" for the My Team dashboard? Gated by ACCESS
 * ROLE: admins, or anyone whose access-role layer is Manager or more senior
 * (layer ≤ DEFAULT_PRIVATE_MIN_LAYER). Users/unassigned don't see it.
 */
import { useProfile } from '../profile/ProfileProvider';
import { accessRoleLayer, DEFAULT_PRIVATE_MIN_LAYER } from '@daaily/shared';

export function useIsManager(): boolean {
  const { state } = useProfile();
  if (state.status !== 'ready') return false;
  if (state.isAdmin) return true;
  return accessRoleLayer(state.config, state.user.accessRole) <= DEFAULT_PRIVATE_MIN_LAYER;
}
